<div class="mat-tel-input-container d-flex align-items-center">
    <button
            [id]="id+'-country-selector'"
        type="button"
        mat-button
        [matMenuTriggerFor]="menu"
        class="country-selector"
        [disabled]="disabled"
        [attr.aria-label]="'Select country code, currently ' + (selectedCountry?.name || '') + (selectedCountry?.dialCode ? ' +' + selectedCountry.dialCode : '')"
        [attr.aria-controls]="menu.id + '-panel'"
        [attr.data-test-id]="testId + '.country-selector-button'"
    >
        <div class="d-flex align-items-center" aria-hidden="true">
            <span *ngIf="preferredCountriesInDropDown.length > 1" class="country-selector-flag flag" [attr.data-test-id]="testId + '.country-selector-flag'" [ngClass]="selectedCountry?.flagClass"></span>
            <span class="country-selector-code" [attr.data-test-id]="testId + '.country-selector-code'" *ngIf="selectedCountry?.dialCode">
			    +{{selectedCountry.dialCode}}
		    </span>
        </div>
    </button>
    <mat-menu #menu="matMenu"
              class="mat-tel-input-mat-menu-panel">
        <input [id]="id+'-country-search'"
            *ngIf="enableSearch"
            class="country-search"
            [(ngModel)]="searchCriteria"
            type="text"
            [placeholder]="searchPlaceholder"
            (click)="$event.stopPropagation()"
            [attr.data-test-id]="testId + '.country-search-input'"
        />
        <ng-container *ngIf="!searchCriteria">
            <button [id]="id+'-country-'+country.alpha3"
                type="button"
                mat-menu-item
                class="country-list-button"
                *ngFor="let country of preferredCountriesInDropDown"
                (click)="onCountrySelect(country, focusable)"
                [attr.data-test-id]="testId + '.preferred-country-option.' + country.alpha3.toLowerCase()"
            >
                <div class="icon-wrapper" aria-hidden="true">
                    <div class="flag" [ngClass]="country.flagClass"></div>
                </div>
                <div class="label-wrapper">
                    {{country.name}}
                    <span *ngIf="country?.dialCode">+{{country.dialCode}}</span>
                </div>
            </button>
            <mat-divider *ngIf="preferredCountriesInDropDown?.length"></mat-divider>
        </ng-container>
        <ng-container *ngFor="let country of allCountries">
            <button
                    [id]="id+'-country-'+country.alpha3"
                type="button"
                mat-menu-item
                *ngIf="country | searchCountry: searchCriteria"
                class="country-list-button"
                (click)="onCountrySelect(country, focusable)"
                [attr.data-test-id]="testId + '.country-option.' + country.alpha3.toLowerCase()"
            >
                <div class="icon-wrapper" aria-hidden="true">
                    <div class="flag" [ngClass]="country.flagClass"></div>
                </div>
                <div class="label-wrapper">
                    {{country.name}} +{{country.dialCode}}
                </div>
            </button>
        </ng-container>
    </mat-menu>
    <input [id]="id+'-input'"
        matInput
        type="tel"
        inputmode="tel"
        class="mt-1"
        autocomplete="tel"
        maxlength="14"
        [ngClass]="cssClass"
        (blur)="onTouched()"
        (input)="onPhoneNumberAutoFill($event)"
        [(ngModel)]="phoneNumber"
        (ngModelChange)="onPhoneNumberChange()"
        [disabled]="disabled"
        [aria-describedby]="describedBy"
        [attr.aria-label]="inputAriaLabel || null"
        #focusable
        [attr.data-test-id]="testId + '-input'"
    />
</div>
